import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Notfound from "./pages/notfound/NotFound";
import HomePage from './HomePage';
import RegisterPage from "./pages/register/register";
import EmailValidation from "./pages/authval/Email-valpdation";
import AdminDashboard from './pages/admin/Dashboard';
import UserDashboard from './pages/user/Dashboard';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import UnauthorizedPage from './pages/unauthorized/Unauthorized';
import SignOutPage from './pages/authval/Logout';
import ProtectedRoute from "./Protected";

// Admin pages
import AdminFrame from './pages/admin/Adminframe';
import Calender from './pages/admin/calender/Calender';
import BlogDashboard from './pages/admin/blog/Dashboard';
import ClassManagement from './pages/user/classmanagement/ClassManagement';
import WebsiteDashboard from './pages/website/Dashboard';
import PasswordReset from './pages/passwordreset/PasswordReset';
import StaffsPage from "./pages/admin/team/team";
import StudentsPage from "./pages/admin/students/Students";
import LeavePage from "./pages/admin/Leaves";
import BorrowPage from "./pages/admin/Borrow";
import NextOfKeen from './pages/admin/nextofkeen/NextOfKeen'
import LaptopsPage from "./pages/admin/Laptops";
import Distribution from "./pages/admin/Distribution";
import Parent from "./pages/admin/parents/Parents";
import LeaveCredit from './pages/admin/LeaveCredits';
import AssetsAudit from './pages/admin/accounting/AssetsAudit';

// Web Pages
import WebsiteFrame from './pages/website/Websiteframe';
import SettingsPage from './pages/website/manage/Settings';
import AboutusPage from './pages/website/manage/AboutUs';
import Background from './pages/website/manage/Background';
import Department from './pages/website/manage/Departments';
import Services from './pages/website/manage/Services';
import News from './pages/website/manage/News';
import Modules from './pages/website/manage/Modules';
import WhySteam from './pages/website/manage/WhySteam';
import Events from './pages/website/manage/Event';
import Csr from './pages/website/manage/Csr';
import CsrEvents from './pages/website/manage/CsrEvents';
import OurClients from './pages/website/manage/OurClients';
import Blog from './pages/website/manage/Blog';
import Adverts from './pages/website/manage/Adverts';
import Newsletter from './pages/website/manage/NewsLetter';
import Gallery from './pages/website/manage/Gallery';
import Testimonials from './pages/website/manage/Testmonials';
import OurPartners from './pages/website/manage/Partners';
import Projects from './pages/website/manage/Projects';
import SteamProject from './pages/website/manage/SteamProjects';
import Announcement from './pages/website/manage/Annousements';
import PublicHolidays from './pages/website/manage/Holidays';


// 

// Material theme
import { ColorModeContext, useMode } from './theme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import RestrictedTime from './RestrictedTime';
import StaffProfile from './pages/admin/profile/StaffProfile';
import Special from './pages/website/manage/AnnousementsPro';

function App() {
  const [theme, colorMode] = useMode();

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Routes>
            
            <Route path="/" element={<HomePage />} />
            
            {/* Admin routes */}
            <Route element={<ProtectedRoute requiredRole={['hr', 'admin', 'supervisor', 'manager', 'receptionist', 'supperAdmin', 'ceo', 'coo']} />}>
              <Route path="/admin/dashboard" element={ <AdminDashboard />} />
              <Route path="/admin/dashboard/staff/:id" element={<StaffProfile />} />
              <Route path="/admin/dashboard/calender" element={ <AdminFrame><Calender /></AdminFrame>} />
              <Route path="/admin/dashboard/leave" element={ <AdminFrame><LeavePage /></AdminFrame>} />
              <Route path="/admin/dashboard/borrow" element={ <AdminFrame><BorrowPage /></AdminFrame>} />
              <Route path="/admin/dashboard/nextofkin" element={ <AdminFrame><NextOfKeen /></AdminFrame>} />
              <Route path="/admin/dashboard/inventory" element={ <AdminFrame><LaptopsPage /></AdminFrame>} />
              <Route path="/admin/dashboard/distribution" element={ <AdminFrame><Distribution /></AdminFrame>} />
              <Route path="/admin/dashboard/parentsguardians" element={ <AdminFrame><Parent /></AdminFrame>} />
              <Route path="/admin/dashboard/staffs" element={ <AdminFrame><StaffsPage /></AdminFrame>} />
              <Route path="/admin/dashboard/students" element={ <AdminFrame><StudentsPage /></AdminFrame>} />
              <Route path="/admin/dashboard/credit" element={ <AdminFrame><LeaveCredit /></AdminFrame>} />
              <Route path="/admin/dashboard/audit" element={ <AdminFrame><AssetsAudit /></AdminFrame>} />
              
              {/* Datas pages */}
              <Route path="/admin/dashboard/broadcast" element={<BlogDashboard />} />
              
              {/* WEBSITE PAGES - ALL USING WebsiteFrame NOW */}
              <Route path="/website/dashboard" element={<WebsiteDashboard /> } />
              <Route path="/website/dashboard/settings" element={<WebsiteFrame><SettingsPage /></WebsiteFrame> } />
              <Route path="/website/dashboard/announcements" element={<WebsiteFrame><Announcement /></WebsiteFrame> } />
              <Route path="/website/dashboard/special" element={<WebsiteFrame><Special /></WebsiteFrame> } />              {/* ✅ Fixed */}
              <Route path="/website/dashboard/public-holidays" element={<WebsiteFrame><PublicHolidays /></WebsiteFrame> } />              {/* ✅ Fixed */}
              <Route path="/website/dashboard/backgrounds" element={<WebsiteFrame><Background /></WebsiteFrame> } />              {/* ✅ Fixed */}
              <Route path="/website/dashboard/about-us" element={<WebsiteFrame><AboutusPage /></WebsiteFrame> } />                {/* ✅ Fixed */}
              <Route path="/website/dashboard/departments" element={<WebsiteFrame><Department /></WebsiteFrame> } />              {/* ✅ Fixed */}
              <Route path="/website/dashboard/services" element={<WebsiteFrame><Services /></WebsiteFrame> } />                    {/* ✅ Fixed */}
              <Route path="/website/dashboard/projects" element={<WebsiteFrame><Projects /></WebsiteFrame> } />                    {/* ✅ Fixed */}
              <Route path="/website/dashboard/modules" element={<WebsiteFrame><Modules /></WebsiteFrame> } />                      {/* ✅ Fixed */}
              <Route path="/website/dashboard/why-steam" element={<WebsiteFrame><WhySteam /></WebsiteFrame> } />                    {/* ✅ Fixed */}
              <Route path="/website/dashboard/events" element={<WebsiteFrame><Events /></WebsiteFrame> } />                        {/* ✅ Fixed */}
              <Route path="/website/dashboard/news" element={<WebsiteFrame><News /></WebsiteFrame> } />                            {/* ✅ Fixed */}
              <Route path="/website/dashboard/clients" element={<WebsiteFrame><OurClients /></WebsiteFrame> } />                    {/* ✅ Fixed */}
              <Route path="/website/dashboard/csr" element={<WebsiteFrame><Csr /></WebsiteFrame> } />                              {/* ✅ Fixed */}
              <Route path="/website/dashboard/csr-activity" element={<WebsiteFrame><CsrEvents /></WebsiteFrame> } />                {/* ✅ Fixed */}
              <Route path="/website/dashboard/blog" element={<WebsiteFrame><Blog /></WebsiteFrame> } />                            {/* ✅ Fixed */}
              <Route path="/website/dashboard/adverts" element={<WebsiteFrame><Adverts /></WebsiteFrame> } />                      {/* ✅ Fixed */}
              <Route path="/website/dashboard/newsletter" element={<WebsiteFrame><Newsletter /></WebsiteFrame> } />                {/* ✅ Fixed */}
              <Route path="/website/dashboard/gallery" element={<WebsiteFrame><Gallery /></WebsiteFrame> } />                      {/* ✅ Fixed */}
              <Route path="/website/dashboard/testimonials" element={<WebsiteFrame><Testimonials /></WebsiteFrame> } />              {/* ✅ Fixed */}
              <Route path="/website/dashboard/partners" element={<WebsiteFrame><OurPartners /></WebsiteFrame> } />
              <Route path="/website/dashboard/steam/project" element={<WebsiteFrame><SteamProject /></WebsiteFrame> } />                  {/* ✅ Fixed */}
              
              {/* Adverts page */}
              <Route path="/admin/dashboard/password-reset" element={<PasswordReset />} />
              <Route path="/admin/dashboard/profile" element={<UserDashboard />} />
              {/* Logout page */}
              <Route path="/admin/dashboard/signout" element={<SignOutPage />} />
            </Route>
            
            <Route element={<ProtectedRoute requiredRole="user" />}>
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/dashboard/signout" element={<SignOutPage />} />
            </Route>
            
            <Route element={<ProtectedRoute requiredRole={['hr', 'admin', 'supervisor', 'receptionist', 'supperAdmin', 'user']} />}>
              <Route path="/user/dashboard/broadcast" element={<BlogDashboard />} />
              <Route path="/user/dashboard/classmanagement" element={<ClassManagement />} />
            </Route>
            
            {/* Public routes */}
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/email-validation" element={<EmailValidation />} />
            <Route path="/unauthorized" element={<UnauthorizedPage />} />
            <Route path='/restricted-time' element={<RestrictedTime />} />
            <Route path="*" element={<Notfound />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;